import * as React from 'react';
import { CheckboxList, CheckboxListProps } from '../inputs/Checkbox';
import { FormField } from './FormField';

type CheckboxListFieldProps = CheckboxListProps & {
    label:string
    indent?: boolean
};

export function CheckboxListField(props:CheckboxListFieldProps)
{
    return (
        <FormField 
            label={props.label} 
            inputComponent={
                <CheckboxList {...props} />
            }
            inErrorState={false}
            message=""
        />
    )
}